import React from 'react';
import './CurrentPlansTab.css';

const CurrentPlansTab = () => {
  const plansData = [
    {
      id: 1,
      services: "Private Limited Company",
      plan: "Basic",
      dateProcessed: "18 Aug 2025",
      status: "Paid",
      statusType: "paid",
      duration: "1 year",
      amount: "₹ 7,500/-"
    },
    {
      id: 2,
      services: "Unlisted Public Limited",
      plan: "Premium",
      dateProcessed: "20 Jun 2025",
      status: "Pending",
      statusType: "pending",
      duration: "1 time plan",
      amount: "₹ 35,000/-"
    }
  ];

  return (
    <div className="current-plans-tab">
      <div className="plans-header">
        <h2>Current Plans</h2>
      </div>
      
      <div className="plans-table-container">
        <table className="plans-table">
          <thead>
            <tr>
              <th>Services</th>
              <th>Plan</th>
              <th>Date Processed</th>
              <th>Status</th>
              <th>Duration</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {plansData.map((plan) => (
              <tr key={plan.id}>
                <td className="service-name">{plan.services}</td>
                <td className="plan-type">{plan.plan}</td>
                <td className="date-processed">{plan.dateProcessed}</td>
                <td>
                  <span className={`status-badge ${plan.statusType}`}>
                    {plan.status}
                  </span>
                </td>
                <td className="duration">{plan.duration}</td>
                <td className="amount">{plan.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CurrentPlansTab;
